var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 16C4.71875 9.7868 9.75555 4.75 15.9688 4.75C22.182 4.75 27.2188 9.7868 27.2188 16C27.2188 22.2132 22.182 27.25 15.9688 27.25C9.75555 27.25 4.71875 22.2132 4.71875 16ZM15.9688 3.25C8.92712 3.25 3.21875 8.95837 3.21875 16C3.21875 23.0416 8.92712 28.75 15.9688 28.75C23.0104 28.75 28.7188 23.0416 28.7188 16C28.7188 8.95837 23.0104 3.25 15.9688 3.25ZM15.9688 10.25C15.5545 10.25 15.2188 10.5858 15.2188 11V11.01C15.2188 11.4242 15.5545 11.76 15.9688 11.76H15.9787C16.393 11.76 16.7287 11.4242 16.7287 11.01V11C16.7287 10.5858 16.393 10.25 15.9787 10.25H15.9688ZM15.3595 15.6432C15.5505 15.5476 15.7656 15.7202 15.7138 15.9274L14.7685 19.7088C14.4058 21.1593 15.9116 22.3671 17.2489 21.6985L17.3042 21.6708C17.6747 21.4856 17.8248 21.0351 17.6396 20.6646C17.4543 20.2941 17.0038 20.1439 16.6333 20.3292L16.578 20.3568C16.387 20.4524 16.1719 20.2798 16.2237 20.0726L17.169 16.2912C17.5317 14.8407 16.0259 13.6329 14.6887 14.3015L14.6333 14.3292C14.2629 14.5144 14.1127 14.9649 14.2979 15.3354C14.4832 15.7059 14.9337 15.8561 15.3042 15.6708L15.3595 15.6432Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.a0dcb505aa4ca5f0fa56efa8fa60e0a6.svg";
export { ForwardRef as ReactComponent };